module.exports = __webpack_public_path__ + "static/media/7.6abd5f3b.jpg";